const initialState = {
    booleanDisplayFullscreenVideo: false,
    booleanDisplayTabletVideo: false,
    booleanDisplayMobileVideo: false,
    WebsiteSection: 'none'
}

const videoReducer = (state = initialState, action) => {

    switch (action.type) {

        case 'DISPLAY_VIDEO_MODAL':
            return {
                booleanDisplayFullscreenVideo: action.booleanDisplayFullscreenVideo,
                booleanDisplayTabletVideo: action.booleanDisplayTabletVideo,
                booleanDisplayMobileVideo: action.booleanDisplayMobileVideo,
                WebsiteSection: action.WebsiteSection
            }

        default:
            return state;
    }
    
}


export default videoReducer
